import fireAnalytics from '~/services/analytics/fireAnalytics';
import { AnalyticsSource } from '~/services/analytics/AnalyticsInterfaces';

export const fireViewedExpertsPopup = () =>
  fireAnalytics('Viewed Experts Pop Up');

export const fireClickedExpertsPopup = () =>
  fireAnalytics('Clicked Experts Pop Up');

export const fireVisitedGearExperts = (src?: AnalyticsSource) =>
  fireAnalytics('Visited Gear Experts', src);

export const fireClickedExpertQuiz = (src?: AnalyticsSource) =>
  fireAnalytics('Clicked Expert Quiz', src);

export const fireVisitedWishlist = () => fireAnalytics('Visited Wishlist');

export const fireCreatedWishlist = () => fireAnalytics('Created Wishlist');
